/*
 *  Cart Quantity Selector
 *    Contains scripts for the Cart Qty Selector
 *
 *  Version
 *    1.0.0 - 2023/07/11
 */
import { cartGetCurrent } from '@process-creative/slate-theme-tools';
import { QuantitySelector } from '../../objects/quantity/QuantitySelector';

export class CartQuantitySelector extends QuantitySelector {
  constructor(index, container) {
    super(container);
    this.index = index;
    this.dispatchOnCartFinished = this.dispatchOnCartFinished.bind(this);
  }

  dispatchOnCartFinished(cartData) {
    const event = new CustomEvent('oncartfinished', { detail: { cartData }, bubbles: true });
    document.dispatchEvent(event);
  }

  onQuantityChanged(quantity) {
    this.updateQuantity(quantity);
  }

  updateQuantity(qty) { 
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ quantity: parseInt(qty), line: parseInt(this.index) })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err });
      }
      return response.json();
    })
    .then(data => {
      this.dispatchOnCartFinished(data);
    })
    .catch(error => {
      console.warn('Error updating cart:', error);
    });
  }

  updateClasses() {
    if (this.max != null && this.min != null && this.min >= this.max) {
      this.input.addClass('is-disabled');
      this.input.attr('disabled', 'disabled');
    } else {
      this.input.removeClass('is-disabled');
      this.input.removeAttr('disabled');
    }

    // Update Minus Button
    if (this.min != null && this.getValue() <= this.min) {
      this.minus.addClass('is-disabled');
      this.minus.attr('disabled', 'disabled');
    } else {
      this.minus.removeClass('is-disabled');
      this.minus.removeAttr('disabled');
    }
  }
}